import { UIDiv, UIInput, UILabel } from '@ui';
export class Toggle extends UIDiv {
  constructor(options = {}) {
    super();
    const {
      initialState = false,
      label = '',
      onChange = () => {},
      id = `toggle-${Math.random().toString(36).substring(2, 9)}`,
    } = options;

    this.state = initialState;
    this.onChange = onChange;
    this.id = id;

    this.setClass('flex items-center');

    this.toggleContainer = new UIDiv();
    this.toggleContainer.setClass(
      'relative inline-flex items-center cursor-pointer',
    );

    this.input = new UIInput();
    this.input.setType('checkbox');
    this.input.setId(this.id);
    this.input.setClass('sr-only peer');
    this.input.setChecked(this.state);

    this.slider = new UIDiv();
    this.slider.setClass(
      'w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:translate-x-[-100%] peer-checked:after:border-white after:content-[""] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[var(--o-hive-primary-100)]',
    );

    this.slider.dom.addEventListener('click', event => {
      event.stopPropagation();
      this.toggle();
    });

    if (label) {
      this.labelElement = new UILabel();
      this.labelElement.setFor(this.id);
      this.labelElement.setClass('ms-3 text-sm font-medium');
      this.labelElement.setValue(label);
    }

    this.input.onChange(e => {
      const newState = e.target.checked;
      this.state = newState;
      this.onChange(newState);
    });

    this.toggleContainer.add(this.input);
    this.toggleContainer.add(this.slider);
    this.add(this.toggleContainer);

    if (label) {
      this.add(this.labelElement);
    }
  }

  setState(state) {
    this.state = state;
    this.input.setChecked(state);
  }

  getState() {
    return this.state;
  }

  toggle() {
    const newState = !this.state;
    this.setState(newState);
    this.onChange(newState);
    return newState;
  }
}

export default Toggle;
